import React from 'react'
import Container from '../components/container'
import Grid from '../components/grid'

export default function Breaker({ content }) {
  const { heading, description } = content ?? {}

  return (
    <section className="bg-secondary text-primary py-8">
      <Container>
        <Grid>
          <div className="col-span-12 md:col-span-10 lg:col-span-7">
            {heading && <h2 className="heading-lg-display">{heading}</h2>}
            {description && <p className="mt-4 body-bs">{description}</p>}
          </div>
        </Grid>
      </Container>
    </section>
  )
}
